import { actionCreatorFactory } from 'typescript-fsa';
import { IDictSymbolsKey } from './dictSymbol.interface';

export namespace DictSymbolAction {
  const actionCreator = actionCreatorFactory('DICT_SYMBOL');

  export const loadList = actionCreator.async<IDictSymbolsKey, string[]>('LOAD_LIST');

  export const destroy = actionCreator('DESTROY');
}
